
export const payoutFeeInfoSections = [
  {
    region: "China",
    bankSettlementSupportCapabilities: "~$100m USD (Year 1)",
    countries: [
      {
        country: "Hong Kong",
        entries: [
          { currency: "HKD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$5 USD", transferLimit: "999,999,999 HKD" },
          { currency: "USD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$8 USD", transferLimit: "Unlimited" },
          { currency: "CNH", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "HKD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "CAD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
    ],
  },
  {
    region: "Macau",
    bankSettlementSupportCapabilities: "",
    countries: [
      {
        country: "Macau",
        entries: [
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "GBP", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
    ],
  },
  {
    region: "Taiwan",
    bankSettlementSupportCapabilities: "",
    countries: [
      {
        country: "Taiwan",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
    ],
  },
  {
    region: "Southeast Asia",
    bankSettlementSupportCapabilities: "~$50m USD (Year 1)",
    countries: [
      {
        country: "Singapore",
        entries: [
          { currency: "SGD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$3 USD", transferLimit: "200,000 SGD" },
          { currency: "SGD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Malaysia",
        entries: [
          { currency: "MYR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Thailand",
        entries: [
          { currency: "THB", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$4.5 USD", transferLimit: "49,999 THB" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Indonesia",
        entries: [
          { currency: "IDR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$3 USD", transferLimit: "Min. 10,000 IDR" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Vietnam",
        entries: [
          { currency: "VND", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "500,000,000 VND" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Philippines",
        entries: [
          { currency: "PHP", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "25,000,000 PHP" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
    ],
  },
  {
    region: "Other Asia",
    bankSettlementSupportCapabilities: "~$50m USD (Year 1)",
    countries: [
      {
        country: "Japan",
        entries: [
          { currency: "JPY", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$10 USD", transferLimit: "1,000,000 JPY" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Korea",
        entries: [
          { currency: "KRW", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$5 USD", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "India",
        entries: [
          { currency: "INR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$5 USD", transferLimit: "15,000,000 INR" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Turkey",
        entries: [
          { currency: "TRY", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$4.5 USD", transferLimit: "85,000 TRY" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Kyrgyzstan",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "UAE",
        entries: [
          { currency: "AED", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$6 USD", transferLimit: "500,000 AED" },
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "AED", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Armenia",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Saudi Arabia",
        entries: [
          { currency: "SAR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$6 USD", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Israel",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Sri Lanka",
        entries: [{ currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Mongolia",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Maldives",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Nepal",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
    ],
  },
  {
    region: "AUS/NZ",
    bankSettlementSupportCapabilities: "~$50m USD (Year 1) / ~$25m USD (Year 1)",
    countries: [
      {
        country: "Australia",
        entries: [
          { currency: "AUD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$5 USD", transferLimit: "Unlimited" },
          { currency: "AUD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "New Zealand",
        entries: [
          { currency: "NZD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$5 USD", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
    ],
  },
  {
    region: "Americas",
    bankSettlementSupportCapabilities: "",
    countries: [
      {
        country: "United States",
        entries: [
          { currency: "USD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Canada",
        entries: [
          { currency: "CAD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$5 USD", transferLimit: "100,000 CAD" },
          { currency: "CAD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Mexico",
        entries: [
          { currency: "MXN", supportMethod: "Local", receivingEntityType: "Individual", settlementCharge: "$5 USD", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Argentina",
        entries: [
          { currency: "ARS", supportMethod: "Local", receivingEntityType: "Individual", settlementCharge: "$5 USD", transferLimit: "10,000,000 ARS" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Colombia",
        entries: [
          { currency: "COP", supportMethod: "Local", receivingEntityType: "Individual", settlementCharge: "$5 USD", transferLimit: "Min. 200,000 COP; Max. 50,000,000 COP" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Brazil",
        entries: [
          { currency: "BRL", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$5 USD", transferLimit: "99,999 BRL" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
        ],
      },
      {
        country: "Bolivia",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Peru",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Chile",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Costa Rica",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
      {
        country: "Uruguay",
        entries: [{ currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }],
      },
    ],
  },
  {
    region: "Europe",
    bankSettlementSupportCapabilities: "~$50m USD (Year 1)",
    countries: [
      {
        country: "Austria",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }

        ]
      },
      {
        country: "Belgium",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Czech Republic",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Germany",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Spain",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "France",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "UK",
        entries: [
          { currency: "GBP", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$3 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "GBP", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Cayman Islands",
        entries: [
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Ireland",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Italy",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Luxembourg",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Netherlands",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Portugal",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Poland",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Croatia",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Switzerland",
        entries: [
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Finland",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Sweden",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Lithuania",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Denmark",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Estonia",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Bulgaria",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Greece",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Hungary",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Latvia",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Romania",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Slovenia",
        entries: [
          { currency: "EUR", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$2 USD", transferLimit: "Unlimited" },
          { currency: "EUR", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },

    ],
  },
  {
    region: "Africa",
    bankSettlementSupportCapabilities: "~$100m USD (Year 1)",
    countries: [
      {
        country: "Nigeria",
        entries: [
          { currency: "NGN", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$3 USD", transferLimit: "10,000,000 NGN" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Ghana",
        entries: [
          { currency: "GHS", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "NO SUPPORT", transferLimit: "50,000 GHS" },
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Kenya",
        entries: [
          { currency: "KES", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "NO SUPPORT", transferLimit: "1,000,000 KES" }
        ]
      },
      {
        country: "Egypt",
        entries: [
          { currency: "EGP", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$4.5 USD", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Morocco",
        entries: [
          { currency: "MAD", supportMethod: "Local", receivingEntityType: "Company/Individual", settlementCharge: "$18 USD", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Mauritius",
        entries: [
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Ethiopia",
        entries: [
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
      {
        country: "Zambia",
        entries: [
          { currency: "USD", supportMethod: "SWIFT", receivingEntityType: "Company/Individual", settlementCharge: "OUR ($35USD)", transferLimit: "Unlimited" }
        ]
      },
    ],
  },
];

